import React, { Component } from "react";
import "./Filter.scss";
import CloseIcon from "@material-ui/icons/Close";
import Slider from "@material-ui/core/Slider";

import { ReactComponent as Type_2_img } from "../../assets/Sockets/type_2_icon.svg";
import { ReactComponent as Combo_icon } from "../../assets/Sockets/combo_icon.svg";
import { ReactComponent as Phase_icon } from "../../assets/Sockets/phase_icon.svg";
import { ReactComponent as Schuko_icon } from "../../assets/Sockets/schuko_icon.svg";
import { ReactComponent as By_card_icon } from "../../assets/payment_options/by_card_icon.svg";
import { ReactComponent as By_cash_icon } from "../../assets/payment_options/by_cash_icon.svg";
import { ReactComponent as By_phone_icon } from "../../assets/payment_options/by_phone_icon.svg";
import { ReactComponent as Free_icon } from "../../assets/payment_options/free_icon.svg";
import { ReactComponent as Wifi_icon } from "../../assets/Incloud/wifi_icon.svg";
import { ReactComponent as Loading_icon } from "../../assets/Incloud/loading_icon.svg";
import { ReactComponent as Parking_icon } from "../../assets/Incloud/parking_icon.svg";
import { ReactComponent as Restoom_icon } from "../../assets/Incloud/restoom_icon.svg";
import { ReactComponent as Shopping_icon } from "../../assets/Incloud/shopping_icon.svg";

import { ReactComponent as Rates_icon } from "../../assets/images//rates_icon.svg";
import { ReactComponent as Charging_power_icon } from "../../assets/images//charging_power_icon.svg";
import { ReactComponent as Connection_type_icon } from "../../assets/images//connection_type_icon.svg";
import { ReactComponent as Include_filter_icon } from "../../assets/images//include_filter_icon.svg";
import { ReactComponent as Operators_filter_icon } from "../../assets/images//operators_filter_icon.svg";
import { ReactComponent as Payments_filter_icon } from "../../assets/images//payments_filter_icon.svg";
import { ReactComponent as Socket_icon } from "../../assets/images//socket_icon.svg";
import { ReactComponent as Layers_icon } from "../../assets/images/layers_icon.svg";

import Afkon_Logo from "../../assets/operator_logo/ev-on.png";
import EvEgde_Logo from "../../assets/operator_logo/EvEgde_Logo.png";
import EVCharge_Logo from "../../assets/operator_logo/EVCharge_Logo.png";
import Gnrgy_img from "../../assets/operator_logo/Gnrgy.png";
import GreenSpot_Logo from "../../assets/operator_logo/GreenSpot_Logo.png";
import Sonol_Logo from "../../assets/operator_logo/Sonol_Logo.png";
import Netzer_Logo from "../../assets/operator_logo/netzer.png";
import Ev4u_Logo from "../../assets/operator_logo/ev4u.png";
import EdgeControl_Logo from "../../assets/operator_logo/edge-control.png";
import ScalaEv_Logo from "../../assets/operator_logo/scalaev.png";
import ViMore_Logo from "../../assets/operator_logo/vimore.png";
import Nofar_Logo from "../../assets/operator_logo/nofar.png";
import Greems_Logo from "../../assets/operator_logo/greems.png";
import TDSD_Logo from "../../assets/operator_logo/tdsd.png";
import SevenEv_Logo from "../../assets/operator_logo/sevenev.png";
import Lishatech_Logo from "../../assets/operator_logo/lishatech.png";
import Doralurban_Logo from "../../assets/operator_logo/doral-urban.png";

import zenev_Logo from "../../assets/operator_logo/zenev.png";
import enova_Logo from "../../assets/operator_logo/enova.png";
import interev_Logo from "../../assets/operator_logo/interev.png";

import evplus_Logo from "../../assets/operator_logo/ev-plus.png";
import amisragreen_Logo from "../../assets/operator_logo/amisragreen.png";
import advice_Logo from "../../assets/operator_logo/advice.png";
import evtech_Logo from "../../assets/operator_logo/evtech.png";

import {
  ProviderConsts,
  ConstClass,
  ConnectorType,
  PriceType,
  IncludesType,
} from "../../entities/iconData";
import { BrowserLanguage } from "../../entities/BrowserLanguage";
import filter_icon from "../../assets/images/filter_icon.png";
import filter_icon_full_color from "../../assets/images/filter_icon_full_color.png";
import station_1_icon from "../../assets/images/station_1_icon.png";
import { ReactComponent as All_img_svg } from "../../assets/images/all_img_svg.svg";
import ReactTooltip from "react-tooltip";
import { StringsData } from "../../entities/StringsData";
import Layers from "../Layers/Layers";
import Data from "../../data.json";

import ProvidersCheckboxes from "./FilterComponents/ProvidersList";
// const operatorsArr = ["ALL_OPERATORS", "PROVIDER_AFKON"];

const allTypesClass = new ConstClass();
const allTypesConnectors = allTypesClass.allTypesConnectors;
const allTypesOperators = allTypesClass.allTypesOperators;
const allTypesPayment = allTypesClass.allTypesPayment;
const allTypesIncludes = allTypesClass.allTypesIncludes;

const changePowerMarks = [
  { value: 0, label: "0" },
  { value: 70, label: "70" },
  { value: 140, label: "140" },
  { value: 210, label: "210" },
  { value: 280, label: "280" },
  { value: 350, label: "350" },
];
const rateMarks = [
  { value: 1, label: "-" },
  { value: 1, label: "₪1" },
  { value: 5.85, label: "₪5.85" },
];
const socketsNumberMarks = [
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
  { value: 5, label: "5" },
  { value: 6, label: "5>" },
];

// Define the starting tabindex as a constant.
const INITIAL_FILTERS_TABINDEX = 11;

/* --- CustomPowerSlider Component --- 
   Sets thumb's tabindex to INITIAL_FILTERS_TABINDEX + 1 when isFilterOpen is true,
   otherwise removes the tabindex.
*/
interface CustomPowerSliderProps {
  isFilterOpen: boolean;
  [key: string]: any;
}

class CustomPowerSlider extends Component<CustomPowerSliderProps> {
  sliderContainerRef = React.createRef<HTMLDivElement>();

  componentDidMount() {
    this.updateThumbTabIndex();
  }

  componentDidUpdate() {
    this.updateThumbTabIndex();
  }

  updateThumbTabIndex() {
    if (this.sliderContainerRef.current) {
      const thumb = this.sliderContainerRef.current.querySelector(
        ".MuiSlider-thumb"
      ) as HTMLElement | null;
      if (thumb) {
        if (this.props.isFilterOpen) {
          thumb.tabIndex = INITIAL_FILTERS_TABINDEX + 5;
        } else {
          thumb.removeAttribute("tabindex");
        }
      }
    }
  }

  render() {
    const { isFilterOpen, value, ...otherProps } = this.props;
    const ariaValueText =
      typeof value === "number" ? `${value} קילו וואט שעה` : "";

    return (
      <div ref={this.sliderContainerRef}>
        <Slider {...otherProps} value={value} aria-valuetext={ariaValueText} />
      </div>
    );
  }
}

/* --- CustomSocketSlider Component --- 
   Sets thumb's tabindex to INITIAL_FILTERS_TABINDEX + 2 when isFilterOpen is true,
   otherwise removes the tabindex.
*/
interface CustomSocketSliderProps {
  isFilterOpen: boolean;
  [key: string]: any;
}

class CustomSocketSlider extends Component<CustomSocketSliderProps> {
  sliderContainerRef = React.createRef<HTMLDivElement>();

  componentDidMount() {
    this.updateThumbTabIndex();
  }

  componentDidUpdate() {
    this.updateThumbTabIndex();
  }

  updateThumbTabIndex() {
    if (this.sliderContainerRef.current) {
      const thumb = this.sliderContainerRef.current.querySelector(
        ".MuiSlider-thumb"
      ) as HTMLElement | null;
      if (thumb) {
        if (this.props.isFilterOpen) {
          thumb.tabIndex = INITIAL_FILTERS_TABINDEX + 2;
        } else {
          thumb.removeAttribute("tabindex");
        }
      }
    }
  }

  render() {
    const { isFilterOpen, ...otherProps } = this.props;
    return (
      <div ref={this.sliderContainerRef}>
        <Slider {...otherProps} />
      </div>
    );
  }
}

interface FilterState {
  chargingPowerOpen: boolean;
  socketsNumberOpen: boolean;
  connectionTypeOpen: boolean;
  operatorsOpen: boolean;
  paymentsOpen: boolean;
  includeOpen: boolean;
  ratesOpen: boolean;
  minRate: Number;
  maxRate: Number;
}

interface FilterProps {
  filterPopup: Function;
  changeSelectedConnector: Function;
  changeSelectedOprators: Function;
  changeSelectedPayment: Function;
  changeSelectedInclude: Function;
  handleChangePower: Function;
  handleSocketsNumber: Function;
  handleChangeRates: (values: number[]) => void;
  browserLanguage: BrowserLanguage;
  openFilterPopup: boolean;
  selectedConnectorsArr: string[];
  operatorsArr: string[];
  paymentsArr: string[];
  includeArr: string[];
  powerSelected: number;
  socektNumber: number;
  stringsFromServer: StringsData;
  layersPopup: Function;
  providersArr: any[];
  aggregatedRateMax: number; // the maximum maxPerKwh from all stations
}

class Filter extends Component<FilterProps, FilterState> {
  // Ref for the filter container (used for focus trapping)
  filterContainerRef = React.createRef<HTMLDivElement>();
  lastFocusedElement: HTMLElement | null = null;

  closeButtonRef = React.createRef<HTMLSpanElement>();

  // To store the focus trap handler so it can be removed later.
  focusTrapHandler?: (e: KeyboardEvent) => void;

  constructor(props: FilterProps) {
    super(props);
    const initialMin = 0;
    const initialMax = this.props.aggregatedRateMax ?? 5;

    this.state = {
      chargingPowerOpen: false,
      socketsNumberOpen: false,
      connectionTypeOpen: false,
      operatorsOpen: false,
      paymentsOpen: false,
      includeOpen: false,
      ratesOpen: false,
      minRate: initialMin,
      maxRate: initialMax,
    };
    this.props.handleChangePower(1 as number);
    this.props.handleSocketsNumber(1 as number);
    this.props.handleChangeRates([initialMin, initialMax]);
    changePowerMarks.map((s) => (s.label = s.label + this.getPowerUnitStr()));
    socketsNumberMarks.map(
      (s) => (s.label = s.value === 6 ? this.getSocketNumberMoreStr() : s.label)
    );
  }

  componentDidMount() {
    // If the filter popup is open on mount, set up focus trap.
    if (this.props.openFilterPopup) {
      this.setupFocusTrap();
    }
  }

  componentDidUpdate(prevProps: FilterProps) {
    // When openFilterPopup changes, add or remove focus trap.
    if (!prevProps.openFilterPopup && this.props.openFilterPopup) {
      this.setupFocusTrap();
    } else if (prevProps.openFilterPopup && !this.props.openFilterPopup) {
      this.removeFocusTrap();
    }
  }

  componentWillUnmount() {
    this.removeFocusTrap();
  }

  setupFocusTrap = () => {
    if (!this.props.openFilterPopup || this.focusTrapHandler) return;

    const container = this.filterContainerRef.current;
    if (!container) return;

    const focusableSelectors = `
      a[href],
      button:not([disabled]),
      textarea:not([disabled]),
      input[type="text"]:not([disabled]),
      input[type="radio"]:not([disabled]),
      input[type="checkbox"]:not([disabled]),
      select:not([disabled]),
      [tabindex]:not([tabindex="-1"])
    `;

    const getFocusable = () =>
      Array.from(
        container.querySelectorAll<HTMLElement>(focusableSelectors)
      ).filter(
        (el) =>
          !el.hasAttribute("disabled") &&
          el.tabIndex !== -1 &&
          el.offsetParent !== null
      );

    const focusableElements = getFocusable();
    if (focusableElements.length === 0) return;

    const first = focusableElements[0];
    const last = focusableElements[focusableElements.length - 1];

    this.focusTrapHandler = (e: KeyboardEvent) => {
      const active = document.activeElement as HTMLElement;
      if (e.key === "Tab") {
        const currentFocusable = getFocusable();
        const firstEl = currentFocusable[0];
        const lastEl = currentFocusable[currentFocusable.length - 1];

        if (e.shiftKey) {
          if (active === firstEl || !container.contains(active)) {
            e.preventDefault();
            lastEl.focus();
          }
        } else {
          if (active === lastEl || !container.contains(active)) {
            e.preventDefault();
            firstEl.focus();
          }
        }
      }
    };

    document.addEventListener("keydown", this.focusTrapHandler);
    document.body.style.overflow = "hidden";

    Array.from(document.body.children).forEach((el) => {
      if (el !== container) el.setAttribute("aria-hidden", "true");
    });

    setTimeout(() => first.focus(), 0);
  };

  removeFocusTrap = () => {
    const container = this.filterContainerRef.current;
    if (container && this.focusTrapHandler) {
      document.removeEventListener("keydown", this.focusTrapHandler);
      this.focusTrapHandler = undefined;
    }

    

    document.body.style.overflow = "";

    const siblings = Array.from(document.body.children);
    siblings.forEach((el) => el.removeAttribute("aria-hidden"));
  };

  handleChangeRates = (newValue: number[]) => {
    this.setState({
      minRate: newValue[0],
      maxRate: newValue[1],
    });
  };

  getPowerUnitStr(): string {
    switch (this.props.browserLanguage) {
      case BrowserLanguage.en:
        return "kWH";
      case BrowserLanguage.he:
        return 'קו"ט';
      case BrowserLanguage.ru:
        return "kWH";
      case BrowserLanguage.ar:
        return "kWH";
      default:
        return "kWH";
    }
  }

  getSocketNumberMoreStr(): string {
    switch (this.props.browserLanguage) {
      case BrowserLanguage.en:
        return "More";
      case BrowserLanguage.he:
        return "עוד";
      case BrowserLanguage.ru:
        return "Более";
      case BrowserLanguage.ar:
        return "أكثر";
      default:
        return "More";
    }
  }

  hasConnectorType = (type: string): boolean => {
    try {
      return (
        Array.isArray(this.props.providersArr) &&
        this.props.providersArr.some(
          (station: any) =>
            Array.isArray(station.connectors) &&
            station.connectors.some((c: any) => c.connectorType === type)
        )
      );
    } catch (err) {
      return false;
    }
  };

  getClearFiltersStr(): string {
    switch (this.props.browserLanguage) {
      case BrowserLanguage.en:
        return "Clear filters";
      case BrowserLanguage.he:
        return "איפוס מסננים";
      case BrowserLanguage.ru:
        return "Сбросить фильтры";
      case BrowserLanguage.ar:
        return "إعادة تعيين الفلاتر";
      default:
        return "Clear filters";
    }
  }

  getPopupClassName(): string {
    const { browserLanguage, openFilterPopup } = this.props;
    if (
      !openFilterPopup &&
      (browserLanguage === BrowserLanguage.he ||
        browserLanguage === BrowserLanguage.ar)
    )
      return "not-show-filter-popup-he";
    if (!openFilterPopup) return "not-show-filter-popup-en";
    if (
      browserLanguage === BrowserLanguage.he ||
      browserLanguage === BrowserLanguage.ar
    )
      return "filter-popup-he";
    return "filter-popup-en";
  }

  getPopupImages = (): JSX.Element => {
    return (
      <div
        className="filter-popup-close"
        onFocus={() => {
          if (!this.props.openFilterPopup) {
          }
        }}
      >
        {this.getPopupTitleFilter(false)}
        {this.getChangePowerImage()}
        {this.getSocketsNumberImage()}
        {this.getConnectionTypeImage()}
        {this.getOperatorTypeImage()}
        {this.getRatesImage()}
        {this.getLayersImage()}
        {/* {this.getPaymentsTypeImage()} */}
        {/* {this.getIncludeTypeImage()} */}
      </div>
    );
  };

  getPopupElement = (): JSX.Element => {
    return (
      <div className="filter-popup">
        {this.getPopupTitleFilter(true)}
        {this.getChangePowerElement()}
        {this.getSocketsNumberElement()}
        {this.getConnectionTypeElement()}
        {this.getOperatorsElement()}
        {this.getRatesElement()}
        {/* {this.getPaymentsElement()} */}
        {/* {this.getIncludeElement()} */}
      </div>
    );
  };

  getPopupTitleFilter = (open: boolean) => {
    return (
      <div className="">
        <a
          href="#"
          className="title-filter"
          style={{ textDecoration: "none" }}
          onClick={() => {
            this.lastFocusedElement = document.activeElement as HTMLElement;

            this.props.filterPopup();
            this.setState({
              
              chargingPowerOpen: false,
              socketsNumberOpen: false,
              connectionTypeOpen: false,
              operatorsOpen: false,
              paymentsOpen: false,
              includeOpen: false,
              ratesOpen: false,
            });
          }}
          tabIndex={INITIAL_FILTERS_TABINDEX}
          role="button"
          aria-label={" פתיחת תפריט מסננים"}
          aria-expanded={open}
        >
          <span className="title-img">
            <img
              src={open ? filter_icon_full_color : filter_icon}
              alt="filter icon"
            />
          </span>
          <span className="title-text">
            {this.props.stringsFromServer.site_FilterTitle}
          </span>
        </a>
      </div>
    );
  };

  // --- Change Power Filter ---
  getChangePowerImage = (): JSX.Element => {
    return (
      <div
        className="icon-and-tooltip"
        onClick={() => {
          this.props.filterPopup();
          this.setState({ chargingPowerOpen: true });
        }}
      >
        <div
          className="img-change-power filter-popup-icon"
          role="button"
          aria-expanded={this.state.chargingPowerOpen}
          aria-label="כפתור סינון על פי הספק טעינה"
          tabIndex={INITIAL_FILTERS_TABINDEX + 1}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              if (!this.props.openFilterPopup) {
                this.props.filterPopup();
              }
              this.setState(
                {
                  chargingPowerOpen: !this.state.chargingPowerOpen,
                  socketsNumberOpen: false,
                  connectionTypeOpen: false,
                  operatorsOpen: false,
                  paymentsOpen: false,
                  includeOpen: false,
                  ratesOpen: false,
                },
                () => {
                  this.removeFocusTrap();
                  setTimeout(() => this.lastFocusedElement?.focus(), 10);
                }
              );
            }
          }}
        >
          <span className="fill-color">
            <Charging_power_icon />
          </span>
        </div>
        <ReactTooltip
          id="img-change-power"
          type="light"
          effect="solid"
          border
          place={
            this.props.browserLanguage === BrowserLanguage.he ||
            this.props.browserLanguage === BrowserLanguage.ar
              ? "left"
              : "right"
          }
        >
          <span className="icon-filter-tooltip">
            {this.props.stringsFromServer.site_FilterByPower}
          </span>
        </ReactTooltip>
      </div>
    );
  };

  getChangePowerElement = (): JSX.Element => {
    const iconClass = this.state.chargingPowerOpen
      ? "filter-popup-icon-open"
      : "filter-popup-icon";
    const arrowClass = this.state.chargingPowerOpen
      ? "arrow-top"
      : "arrow-bottom";
    return (
      <div className="charging-power">
        <div
          className={iconClass}
          role="button"
          aria-expanded={this.state.chargingPowerOpen}
          aria-label=" כפתור סינון על פי הספק טעינה"
          tabIndex={INITIAL_FILTERS_TABINDEX + 1}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              if (!this.props.openFilterPopup) {
                this.props.filterPopup();
              }
              this.setState({
                chargingPowerOpen: !this.state.chargingPowerOpen,
                socketsNumberOpen: false,
                connectionTypeOpen: false,
                operatorsOpen: false,
                paymentsOpen: false,
                includeOpen: false,
                ratesOpen: false,
              });
            }
          }}
          onClick={() =>
            this.setState({
              chargingPowerOpen: !this.state.chargingPowerOpen,
              socketsNumberOpen: false,
              connectionTypeOpen: false,
              operatorsOpen: false,
              paymentsOpen: false,
              includeOpen: false,
              ratesOpen: false,
            })
          }
        >
          <span className="fill-color">
            <Charging_power_icon />
          </span>
          <span className="charging-power-title">
            {this.props.stringsFromServer.site_FilterByPower}
          </span>
          <span className={arrowClass}></span>
        </div>
        <div className="charging-power-slider">
          {this.state.chargingPowerOpen && (
            <div className="slider-filter">
              <CustomPowerSlider
                isFilterOpen={this.state.chargingPowerOpen}
                value={this.props.powerSelected}
                aria-label="סימוני הספק טעינה "
                defaultValue={this.props.powerSelected}
                onChange={(
                  event: React.ChangeEvent<any>,
                  newValue: number | number[]
                ) => this.props.handleChangePower(newValue as number)}
                step={70}
                marks={changePowerMarks}
                min={0}
                max={350}
                track="inverted"
              />
            </div>
          )}
        </div>
      </div>
    );
  };

  // --- Sockets Number Filter ---
  getSocketsNumberImage = (): JSX.Element => {
    return (
      <div
        className="icon-and-tooltip"
        onClick={() => {
          this.props.filterPopup();
          this.setState({ socketsNumberOpen: true });
        }}
      >
        <div
          className="img-socket-number filter-popup-icon"
          role="button"
          aria-expanded={this.state.socketsNumberOpen}
          aria-label="כפתור סינון על פי כמות שקעים"
          tabIndex={INITIAL_FILTERS_TABINDEX + 2}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              if (!this.props.openFilterPopup) {
                this.props.filterPopup();
              }
              this.setState(
                {
                  socketsNumberOpen: !this.state.socketsNumberOpen,
                  chargingPowerOpen: false,
                  connectionTypeOpen: false,
                  operatorsOpen: false,
                  paymentsOpen: false,
                  includeOpen: false,
                  ratesOpen: false,
                },
                () => {
                  this.setupFocusTrap();
                }
              );
            }
          }}
        >
          <span>
            <Socket_icon />
          </span>
        </div>
        <ReactTooltip
          id="img-socket-number"
          type="light"
          effect="solid"
          border
          place={
            this.props.browserLanguage === BrowserLanguage.he ||
            this.props.browserLanguage === BrowserLanguage.ar
              ? "left"
              : "right"
          }
        >
          <span className="icon-filter-tooltip">
            {this.props.stringsFromServer.site_FilterBySocketsNum}
          </span>
        </ReactTooltip>
      </div>
    );
  };

  getSocketsNumberElement = (): JSX.Element => {
    const iconClass = this.state.socketsNumberOpen
      ? "filter-popup-icon-open"
      : "filter-popup-icon";
    const arrowClass = this.state.socketsNumberOpen
      ? "arrow-top"
      : "arrow-bottom";
    return (
      <div className="sockets-number">
        <div
          className={iconClass}
          role="button"
          aria-expanded={this.state.socketsNumberOpen}
          aria-label="כפתור סינון על פי כמות שקעים"
          tabIndex={INITIAL_FILTERS_TABINDEX + 2}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              if (!this.props.openFilterPopup) {
                this.props.filterPopup();
              }
              this.setState({
                socketsNumberOpen: !this.state.socketsNumberOpen,
                chargingPowerOpen: false,
                connectionTypeOpen: false,
                operatorsOpen: false,
                paymentsOpen: false,
                includeOpen: false,
                ratesOpen: false,
              });
            }
          }}
          onClick={() =>
            this.setState({
              socketsNumberOpen: !this.state.socketsNumberOpen,
              chargingPowerOpen: false,
              connectionTypeOpen: false,
              operatorsOpen: false,
              paymentsOpen: false,
              includeOpen: false,
              ratesOpen: false,
            })
          }
        >
          <span>
            <Socket_icon />
          </span>
          <span className="sockets-number-title">
            {this.props.stringsFromServer.site_FilterBySocketsNum}
          </span>
          <span className={arrowClass}></span>
        </div>
        <div className="sockets-number-slider">
          {this.state.socketsNumberOpen && (
            <div className="slider-filter">
              <CustomSocketSlider
                isFilterOpen={this.state.socketsNumberOpen}
                aria-label="Temperature"
                defaultValue={this.props.socektNumber}
                onChange={(
                  event: React.ChangeEvent<any>,
                  newValue: number | number[]
                ) => this.props.handleSocketsNumber(newValue as number)}
                step={1}
                marks={socketsNumberMarks}
                min={1}
                max={6}
                track="inverted"
              />
            </div>
          )}
        </div>
      </div>
    );
  };

  // --- Connection Type Filter ---
  getConnectionTypeImage = (): JSX.Element => {
    return (
      <div
        className="icon-and-tooltip"
        onClick={() => {
          this.props.filterPopup();
          this.setState({ connectionTypeOpen: true });
        }}
      >
        <div
          className="img-connection-type filter-popup-icon"
          role="button"
          aria-expanded={this.state.connectionTypeOpen}
          aria-label="כפתור סינון על פי סוג חיבור"
          tabIndex={INITIAL_FILTERS_TABINDEX + 3}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              if (!this.props.openFilterPopup) {
                this.props.filterPopup();
              }
              this.setState(
                {
                  connectionTypeOpen: !this.state.connectionTypeOpen,
                  chargingPowerOpen: false,
                  socketsNumberOpen: false,
                  operatorsOpen: false,
                  paymentsOpen: false,
                  includeOpen: false,
                  ratesOpen: false,
                },
                () => {
                  this.setupFocusTrap();
                }
              );
            }
          }}
        >
          <span className="fill-color">
            <Connection_type_icon />
          </span>
        </div>
        <ReactTooltip
          id="img-connection-type"
          type="light"
          effect="solid"
          border
          place={
            this.props.browserLanguage === BrowserLanguage.he ||
            this.props.browserLanguage === BrowserLanguage.ar
              ? "left"
              : "right"
          }
        >
          <span className="icon-filter-tooltip">
            {this.props.stringsFromServer.site_FilterByConnType}
          </span>
        </ReactTooltip>
      </div>
    );
  };

  getConnectionTypeElement = (): JSX.Element => {
    const connectorType = new ConnectorType();
    const COMBO = connectorType.COMBO;
    const PHASE = connectorType.PHASE;
    const TYPE_2 = connectorType.TYPE_2;
    const SCHUKO = connectorType.SCHUKO;
    const CHADEMO = connectorType.CHADEMO;

    const iconClass = this.state.connectionTypeOpen
      ? "filter-popup-icon-open"
      : "filter-popup-icon";
    const arrowClass = this.state.connectionTypeOpen
      ? "arrow-top"
      : "arrow-bottom";

    const renderConnectorCheckbox = (
      className: string,
      labelText: string,
      id: string,
      value: string,
      icon: JSX.Element,
      condition: boolean = true
    ) => {
      if (!condition) return null;

      const isChecked = !!this.props.selectedConnectorsArr.find(
        (socket) => socket === value || socket === allTypesConnectors
      );

      return (
        <div
          className={`${className}`}
          role="checkbox"
          aria-checked={isChecked}
          aria-label={`סוג חיבור ${labelText} ${
            isChecked ? "מסומן" : "לא מסומן"
          }`}
          tabIndex={INITIAL_FILTERS_TABINDEX + 3}
          onClick={() => this.props.changeSelectedConnector(value, !isChecked)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              this.props.changeSelectedConnector(value, !isChecked);
            }
          }}
        >
          <input
            type="checkbox"
            id={id}
            name={id}
            value={value}
            checked={isChecked}
            onChange={() => {}}
            aria-hidden="true"
            tabIndex={-1}
          />
          <label
            className={`${id}-label type-checkbox-label`}
            htmlFor={id}
            style={{ pointerEvents: "none" }}
          >
            <span className="type-checkbox-logo">{icon}</span>
          </label>
          <div className="text-image">{labelText}</div>
        </div>
      );
    };

    return (
      <div>
        <div
          className={iconClass}
          role="button"
          aria-expanded={this.state.connectionTypeOpen}
          aria-label="כפתור סינון על פי סוג חיבור"
          tabIndex={INITIAL_FILTERS_TABINDEX + 3}
          onClick={() =>
            this.setState({
              connectionTypeOpen: !this.state.connectionTypeOpen,
              chargingPowerOpen: false,
              socketsNumberOpen: false,
              operatorsOpen: false,
              paymentsOpen: false,
              includeOpen: false,
              ratesOpen: false,
            })
          }
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              this.setState({
                connectionTypeOpen: !this.state.connectionTypeOpen,
                chargingPowerOpen: false,
                socketsNumberOpen: false,
                operatorsOpen: false,
                paymentsOpen: false,
                includeOpen: false,
                ratesOpen: false,
              });
            }
          }}
        >
          <span className="fill-color">
            <Connection_type_icon />
          </span>
          <span className="connection-type-title">
            {this.props.stringsFromServer.site_FilterByConnType}
          </span>
          <span className={arrowClass}></span>
        </div>

        <div className="connection-type-checkbox">
          {this.state.connectionTypeOpen && (
            <>
              {renderConnectorCheckbox(
                "all-checkbox",
                this.props.stringsFromServer.site_FilterAll,
                "allConnection",
                allTypesConnectors,
                <All_img_svg />
              )}

              {renderConnectorCheckbox(
                "type_2-checkbox",
                "type 2",
                "type_2",
                TYPE_2,
                <Type_2_img />
              )}

              {renderConnectorCheckbox(
                "combo-checkbox",
                "combo",
                "combo",
                COMBO,
                <Combo_icon />
              )}

              {renderConnectorCheckbox(
                "schuko-checkbox",
                "schuko",
                "schuko",
                SCHUKO,
                <Schuko_icon />,
                this.hasConnectorType(SCHUKO)
              )}

              {renderConnectorCheckbox(
                "phase-checkbox",
                "phase",
                "phase",
                PHASE,
                <Phase_icon />,
                this.hasConnectorType(PHASE)
              )}

              {renderConnectorCheckbox(
                "combo-checkbox",
                "chademo",
                "chademo",
                CHADEMO,
                <Combo_icon />
              )}
            </>
          )}
        </div>
      </div>
    );
  };

  // --- Operator Type Filter ---
  getOperatorTypeImage = (): JSX.Element => {
    return (
      <div
        className="icon-and-tooltip"
        onClick={() => {
          this.props.filterPopup();
          this.setState({ operatorsOpen: true });
        }}
      >
        <div
          className="img-operator-type filter-popup-icon"
          role="button"
          aria-expanded={this.state.operatorsOpen}
          aria-label=" כפתור סינון על פי ספקים"
          tabIndex={INITIAL_FILTERS_TABINDEX + 4}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              if (!this.props.openFilterPopup) {
                this.props.filterPopup();
              }
              this.setState(
                {
                  operatorsOpen: !this.state.operatorsOpen,
                  chargingPowerOpen: false,
                  socketsNumberOpen: false,
                  connectionTypeOpen: false,
                  paymentsOpen: false,
                  includeOpen: false,
                  ratesOpen: false,
                },
                () => {
                  this.setupFocusTrap();
                }
              );
            }
          }}
        >
          <span className="fill-color">
            <Operators_filter_icon />
          </span>
        </div>
        <ReactTooltip
          id="img-operator-type"
          type="light"
          effect="solid"
          border
          place={
            this.props.browserLanguage === BrowserLanguage.he ||
            this.props.browserLanguage === BrowserLanguage.ar
              ? "left"
              : "right"
          }
        >
          <span className="icon-filter-tooltip">
            {this.props.stringsFromServer.site_FilterByOperators}
          </span>
        </ReactTooltip>
      </div>
    );
  };

  getOperatorsElement = (): JSX.Element => {
    const arrowClass = this.state.operatorsOpen ? "arrow-top" : "arrow-bottom";
    const iconClass = this.state.operatorsOpen
      ? "filter-popup-icon-open"
      : "filter-popup-icon";

    const {
      operatorsArr,
      changeSelectedOprators,
      stringsFromServer,
      providersArr,
    } = this.props;

    return (
      <div>
        <div
          className={iconClass}
          role="button"
          aria-expanded={this.state.operatorsOpen}
          aria-controls="operators-checkbox"
          aria-label={stringsFromServer.site_FilterByOperators}
          tabIndex={INITIAL_FILTERS_TABINDEX + 4}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              this.setState({
                operatorsOpen: !this.state.operatorsOpen,
                chargingPowerOpen: false,
                socketsNumberOpen: false,
                connectionTypeOpen: false,
                paymentsOpen: false,
                includeOpen: false,
                ratesOpen: false,
              });
            }
          }}
          onClick={() => {
            this.setState({
              operatorsOpen: !this.state.operatorsOpen,
              chargingPowerOpen: false,
              socketsNumberOpen: false,
              connectionTypeOpen: false,
              paymentsOpen: false,
              includeOpen: false,
              ratesOpen: false,
            });
          }}
        >
          <span className="fill-color" aria-hidden="true">
            <Operators_filter_icon />
          </span>
          <span className="operators-type-title">
            {stringsFromServer.site_FilterByOperators}
          </span>
          <span className={arrowClass}></span>
        </div>

        <div
          id="operators-checkbox"
          role="region"
          aria-live="polite"
          className="operators-type-checkbox"
        >
          {this.state.operatorsOpen && (
            <div>
              <ProvidersCheckboxes
                operatorsArr={operatorsArr.map(String)}
                changeSelectedOprators={changeSelectedOprators}
                stringsFromServer={{
                  site_FilterAll:
                    stringsFromServer.site_FilterAll || "All Operators",
                }}
                providersArr={providersArr}
                browserLanguage={this.props.browserLanguage}
              />
            </div>
          )}
        </div>
      </div>
    );
  };

  // --- Change Power Filter (Rates) ---
  getRatesImage = (): JSX.Element => {
    return (
      <div
        className="icon-and-tooltip"
        onClick={() => {
          this.props.filterPopup();
          this.setState({ ratesOpen: true });
        }}
      >
        <div
          className="filter-popup-icon"
          role="button"
          aria-expanded={this.state.ratesOpen}
          aria-label=" כפתור סינון על פי מחיר"
          tabIndex={INITIAL_FILTERS_TABINDEX + 5}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              if (!this.props.openFilterPopup) {
                this.props.filterPopup();
              }
              this.setState(
                {
                  chargingPowerOpen: false,
                  socketsNumberOpen: false,
                  connectionTypeOpen: false,
                  operatorsOpen: false,
                  paymentsOpen: false,
                  includeOpen: false,
                  ratesOpen: !this.state.ratesOpen,
                },
                () => {
                  this.setupFocusTrap();
                }
              );
            }
          }}
        >
          <span className="fill-color">
            <Rates_icon />
          </span>
        </div>
        <ReactTooltip
          type="light"
          effect="solid"
          border
          place={
            this.props.browserLanguage === BrowserLanguage.he ||
            this.props.browserLanguage === BrowserLanguage.ar
              ? "left"
              : "right"
          }
        >
          <span className="icon-filter-tooltip">
            {this.props.stringsFromServer.site_FilterByPower}
          </span>
        </ReactTooltip>
      </div>
    );
  };

  getRateMarks(): { value: number; label: string }[] {
    const min = 0;
    const max = this.props.aggregatedRateMax || 5.85;
    const step = 0.5;
    const marks = [];

    for (let value = min; value <= max; value += step) {
      const rounded = parseFloat(value.toFixed(1));
      marks.push({ value: rounded, label: rounded.toString() });
    }

    return marks;
  }

  getRatesElement = (): JSX.Element => {
    const iconClass = this.state.ratesOpen
      ? "filter-popup-icon-open"
      : "filter-popup-icon";
    const arrowClass = this.state.ratesOpen ? "arrow-top" : "arrow-bottom";

    const isRTL =
      this.props.browserLanguage === BrowserLanguage.he ||
      this.props.browserLanguage === BrowserLanguage.ar;

    const rateLabel =
      this.props.stringsFromServer.site_FilterByRates || "Rates";

    let combinedLabel: JSX.Element;

    switch (this.props.browserLanguage) {
      case BrowserLanguage.he:
        combinedLabel = <strong>מחירים (ש&quot;ח לקוט&quot;ש)</strong>;
        break;
      case BrowserLanguage.ru:
        combinedLabel = <strong>Цены (NIS/кВт⋅ч)</strong>;
        break;
      case BrowserLanguage.ar:
        combinedLabel = <strong>الأسعار (NIS/كيلو واط ساعة)</strong>;
        break;
      default:
        combinedLabel = <strong>Rates (NIS/kWh)</strong>;
        break;
    }

    return (
      <div className="charging-power">
        <div
          className={iconClass}
          role="button"
          aria-expanded={this.state.ratesOpen}
          aria-label="כפתור סינון על פי מחיר"
          tabIndex={INITIAL_FILTERS_TABINDEX + 5}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              if (!this.props.openFilterPopup) {
                this.props.filterPopup();
              }
              this.setState({
                chargingPowerOpen: false,
                socketsNumberOpen: false,
                connectionTypeOpen: false,
                operatorsOpen: false,
                paymentsOpen: false,
                includeOpen: false,
                ratesOpen: !this.state.ratesOpen,
              });
            }
          }}
          onClick={() =>
            this.setState({
              chargingPowerOpen: false,
              socketsNumberOpen: false,
              connectionTypeOpen: false,
              operatorsOpen: false,
              paymentsOpen: false,
              includeOpen: false,
              ratesOpen: !this.state.ratesOpen,
            })
          }
        >
          <span className="fill-color">
            <Rates_icon />
          </span>
          <span className="charging-power-title">{rateLabel}</span>
          <span className={arrowClass}></span>
        </div>
        <div className="charging-power-slider">
          {this.state.ratesOpen && (
            <div className="slider-filter">
              <div>{combinedLabel}</div>
              <CustomPowerSlider
                isFilterOpen={this.state.ratesOpen}
                aria-label="Rates Range"
                value={[
                  this.state.minRate as number,

                  this.state.maxRate as number,
                ]}
                onChange={(
                  event: React.ChangeEvent<any>,
                  newValue: number | number[]
                ) => {
                  const [newMin, newMax] = newValue as number[];
                  this.setState({ minRate: newMin, maxRate: newMax });
                  this.props.handleChangeRates([newMin, newMax]);
                }}
                step={0.5}
                marks={this.getRateMarks()}
                min={0.01}
                max={this.props.aggregatedRateMax || 5.85}
                valueLabelDisplay="auto"
                track="normal"
              />
            </div>
          )}
        </div>
      </div>
    );
  };

  // --- Layers Filter (unchanged) ---
  getLayersImage = (): JSX.Element => {
    const ariaLabel =
      this.props.browserLanguage === BrowserLanguage.he
        ? "כפתור שכבות"
        : this.props.browserLanguage === BrowserLanguage.ar
        ? "زر الطبقات"
        : "Layers button";

    return (
      <div className="icon-and-tooltip">
        <div
          className={`filter-popup-icon layers ${this.props.browserLanguage}`}
          role="button"
          aria-label={ariaLabel}
          tabIndex={INITIAL_FILTERS_TABINDEX + 8}
          onClick={() => this.props.layersPopup()}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              this.props.layersPopup();
            }
          }}
          aria-describedby="layers"
        >
          <span className="fill-color">
            <Layers_icon />
          </span>
        </div>
        <ReactTooltip
          id="layers"
          type="light"
          effect="solid"
          border
          place={
            this.props.browserLanguage === BrowserLanguage.he ||
            this.props.browserLanguage === BrowserLanguage.ar
              ? "left"
              : "right"
          }
        >
          <span className="icon-filter-tooltip">
            {this.props.stringsFromServer.site_LayesTitle}
          </span>
        </ReactTooltip>
      </div>
    );
  };

  // --- Payments Filter ---
  getPaymentsTypeImage = (): JSX.Element => {
    return (
      <div
        className="icon-and-tooltip"
        onClick={() => {
          this.props.filterPopup();
          this.setState({ paymentsOpen: true });
        }}
      >
        <div
          className="img-payment-type filter-popup-icon"
          role="button"
          aria-expanded={this.state.paymentsOpen}
          // write logic if languae is eng the aria-label is in english
          aria-label=" כפתור סינון על פי סוג תשלום"
          tabIndex={INITIAL_FILTERS_TABINDEX + 6}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              if (!this.props.openFilterPopup) {
                this.props.filterPopup();
              }
              this.setState(
                {
                  paymentsOpen: !this.state.paymentsOpen,
                  chargingPowerOpen: false,
                  socketsNumberOpen: false,
                  connectionTypeOpen: false,
                  operatorsOpen: false,
                  includeOpen: false,
                  ratesOpen: false,
                },
                () => {
                  this.setupFocusTrap();
                }
              );
            }
          }}
        >
          <span className="fill-color">
            <Payments_filter_icon />
          </span>
        </div>
        <ReactTooltip
          id="img-payment-type"
          type="light"
          effect="solid"
          border
          place={
            this.props.browserLanguage === BrowserLanguage.he ||
            this.props.browserLanguage === BrowserLanguage.ar
              ? "left"
              : "right"
          }
        >
          <span className="icon-filter-tooltip">
            {this.props.stringsFromServer.site_FilterByPayment}
          </span>
        </ReactTooltip>
      </div>
    );
  };

  getPaymentsElement = (): JSX.Element => {
    const priceType = new PriceType();
    const by_card = priceType.by_card;
    const by_cash = priceType.by_cash;
    const by_phone = priceType.by_phone;
    const free = priceType.free;
    const { paymentsArr, changeSelectedPayment, stringsFromServer } =
      this.props;
    const arrowClass = this.state.paymentsOpen ? "arrow-top" : "arrow-bottom";
    const iconClass = this.state.paymentsOpen
      ? "filter-popup-icon-open"
      : "filter-popup-icon";
    return (
      <div>
        <div
          className={iconClass}
          role="button"
          aria-expanded={this.state.paymentsOpen}
          aria-label=" כפתור סינון על פי סוג תשלום"
          tabIndex={INITIAL_FILTERS_TABINDEX + 6}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              if (!this.props.openFilterPopup) {
                this.props.filterPopup();
              }
              this.setState({
                paymentsOpen: !this.state.paymentsOpen,
                chargingPowerOpen: false,
                socketsNumberOpen: false,
                connectionTypeOpen: false,
                operatorsOpen: false,
                includeOpen: false,
                ratesOpen: false,
              });
            }
          }}
          onClick={() =>
            this.setState({
              paymentsOpen: !this.state.paymentsOpen,
              chargingPowerOpen: false,
              socketsNumberOpen: false,
              connectionTypeOpen: false,
              operatorsOpen: false,
              includeOpen: false,
              ratesOpen: false,
            })
          }
        >
          <span className="fill-color">
            <Payments_filter_icon />
          </span>
          <span className="payments-type-title">
            {stringsFromServer.site_FilterByPayment}
          </span>
          <span className={arrowClass}></span>
        </div>
        <div className="include-type-checkbox">
          {this.state.paymentsOpen && (
            <div className="">
              <div className="all-checkbox">
                <input
                  type="checkbox"
                  id="allPayments"
                  name="allPayments"
                  value={allTypesPayment}
                  checked={
                    paymentsArr.find((payment) => payment === allTypesPayment)
                      ? true
                      : false
                  }
                  onChange={(e: React.FormEvent<HTMLInputElement>) =>
                    changeSelectedPayment(
                      allTypesPayment,
                      e.currentTarget.checked
                    )
                  }
                />
                <label
                  className="all-label type-checkbox-label"
                  htmlFor="allPayments"
                >
                  <span className="type-checkbox-logo">
                    <All_img_svg />
                  </span>
                </label>
                <div className="text-image">
                  {stringsFromServer.site_FilterAll}{" "}
                </div>
              </div>
              <div className="by-card-checkbox">
                <input
                  type="checkbox"
                  id="by_card"
                  name="by_card"
                  value={by_card}
                  checked={
                    paymentsArr.find(
                      (payment) =>
                        payment === by_card || payment === allTypesPayment
                    ) !== undefined
                      ? true
                      : false
                  }
                  onChange={(e: React.FormEvent<HTMLInputElement>) =>
                    changeSelectedPayment(by_card, e.currentTarget.checked)
                  }
                />
                <label
                  className="by-card-label type-checkbox-label"
                  htmlFor="by_card"
                >
                  <span className="type-checkbox-logo">
                    <By_card_icon />
                  </span>
                </label>
                <div className="text-image">
                  {stringsFromServer.site_FilterPayByCard}{" "}
                </div>
              </div>
              <div className="by-cash-checkbox">
                <input
                  type="checkbox"
                  id="by_cash"
                  name="by_cash"
                  value={by_cash}
                  checked={
                    paymentsArr.find(
                      (payment) =>
                        payment === by_cash || payment === allTypesPayment
                    )
                      ? true
                      : false
                  }
                  onChange={(e: React.FormEvent<HTMLInputElement>) =>
                    changeSelectedPayment(by_cash, e.currentTarget.checked)
                  }
                />
                <label
                  className="by-cash-label type-checkbox-label"
                  htmlFor="by_cash"
                >
                  <span className="type-checkbox-logo">
                    <By_cash_icon />
                  </span>
                </label>
                <div className="text-image">
                  {stringsFromServer.site_FilterPayByCash}{" "}
                </div>
              </div>

              <div className="by-phone-checkbox">
                <input
                  type="checkbox"
                  id="by_phone"
                  name="by_phone"
                  value={by_phone}
                  checked={
                    paymentsArr.find(
                      (payment) =>
                        payment === by_phone || payment === allTypesPayment
                    )
                      ? true
                      : false
                  }
                  onChange={(e: React.FormEvent<HTMLInputElement>) =>
                    changeSelectedPayment(by_phone, e.currentTarget.checked)
                  }
                />
                <label
                  className="by-phone-label type-checkbox-label"
                  htmlFor="by_phone"
                >
                  <span className="type-checkbox-logo">
                    <By_phone_icon />
                  </span>
                </label>
                <div className="text-image">
                  {stringsFromServer.site_FilterPayByPhone}{" "}
                </div>
              </div>
              <div className="free-checkbox">
                <input
                  type="checkbox"
                  id="free"
                  name="free"
                  value={free}
                  checked={
                    paymentsArr.find(
                      (payment) =>
                        payment === free || payment === allTypesPayment
                    )
                      ? true
                      : false
                  }
                  onChange={(e: React.FormEvent<HTMLInputElement>) =>
                    changeSelectedPayment(free, e.currentTarget.checked)
                  }
                />
                <label
                  className="free-label type-checkbox-label"
                  htmlFor="free"
                >
                  <span className="type-checkbox-logo">
                    <Free_icon />
                  </span>
                </label>
                <div className="text-image">
                  {stringsFromServer.site_FilterPayFree}{" "}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  // --- Include Filter ---
  getIncludeTypeImage = (): JSX.Element => {
    return (
      <div
        className="icon-and-tooltip"
        onClick={() => {
          this.props.filterPopup();
          this.setState({ includeOpen: true });
        }}
      >
        <div
          className="img-include-type filter-popup-icon"
          role="button"
          aria-expanded={this.state.includeOpen}
          aria-label=" כפתור סינון על פי הכלה"
          tabIndex={INITIAL_FILTERS_TABINDEX + 7}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              if (!this.props.openFilterPopup) {
                this.props.filterPopup();
              }
              this.setState({
                includeOpen: !this.state.includeOpen,
                chargingPowerOpen: false,
                socketsNumberOpen: false,
                connectionTypeOpen: false,
                operatorsOpen: false,
                paymentsOpen: false,
                ratesOpen: false,
              });
            }
          }}
        >
          <span className="fill-color">
            <Include_filter_icon />
          </span>
        </div>
        <ReactTooltip
          id="img-include-type"
          type="light"
          effect="solid"
          border
          place={
            this.props.browserLanguage === BrowserLanguage.he ||
            this.props.browserLanguage === BrowserLanguage.ar
              ? "left"
              : "right"
          }
        >
          <span className="icon-filter-tooltip">
            {this.props.stringsFromServer.site_FilterByInclude}
          </span>
        </ReactTooltip>
      </div>
    );
  };

  getIncludeElement = (): JSX.Element => {
    const { includeArr, changeSelectedInclude, stringsFromServer } = this.props;
    const arrowClass = this.state.includeOpen ? "arrow-top" : "arrow-bottom";
    const iconClass = this.state.includeOpen
      ? "filter-popup-icon-open"
      : "filter-popup-icon";
    return (
      <div>
        <div
          className={iconClass}
          role="button"
          aria-expanded={this.state.includeOpen}
          aria-label=" כפתור סינון על פי הכלה"
          tabIndex={INITIAL_FILTERS_TABINDEX + 7}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              if (!this.props.openFilterPopup) {
                this.props.filterPopup();
              }
              this.setState({
                includeOpen: !this.state.includeOpen,
                chargingPowerOpen: false,
                socketsNumberOpen: false,
                connectionTypeOpen: false,
                operatorsOpen: false,
                paymentsOpen: false,
                ratesOpen: false,
              });
            }
          }}
          onClick={() =>
            this.setState({
              includeOpen: !this.state.includeOpen,
              chargingPowerOpen: false,
              socketsNumberOpen: false,
              connectionTypeOpen: false,
              operatorsOpen: false,
              paymentsOpen: false,
              ratesOpen: false,
            })
          }
        >
          <span className="fill-color">
            <Include_filter_icon />
          </span>
          <span className="include-type-title">
            {stringsFromServer.site_FilterByInclude}
          </span>
          <span className={arrowClass}></span>
        </div>
        <div className="include-type-checkbox" tabIndex={0}>
          {this.state.includeOpen && (
            <div className="">
              <div className="all-checkbox">
                <input
                  type="checkbox"
                  id="allIncludes"
                  name="allIncludes"
                  value={allTypesIncludes}
                  checked={
                    includeArr.find((include) => include === allTypesIncludes)
                      ? true
                      : false
                  }
                  onChange={(e: React.FormEvent<HTMLInputElement>) =>
                    changeSelectedInclude(
                      allTypesIncludes,
                      e.currentTarget.checked
                    )
                  }
                />
                <label
                  className="all-label type-checkbox-label"
                  htmlFor="allIncludes"
                >
                  <span className="type-checkbox-logo">
                    <All_img_svg />
                  </span>
                </label>
                <div className="text-image">
                  {stringsFromServer.site_FilterAll}{" "}
                </div>
              </div>
              <div className="wifi-checkbox">
                <input
                  type="checkbox"
                  id="wifi"
                  name="wifi"
                  value="wifi"
                  checked={
                    includeArr.find(
                      (include) =>
                        include === IncludesType.WIFI ||
                        include === allTypesIncludes
                    )
                      ? true
                      : false
                  }
                  onChange={(e: React.FormEvent<HTMLInputElement>) =>
                    changeSelectedInclude(
                      IncludesType.WIFI,
                      e.currentTarget.checked
                    )
                  }
                />
                <label
                  className="wifi-label type-checkbox-label"
                  htmlFor="wifi"
                >
                  <span className="type-checkbox-logo">
                    <Wifi_icon />
                  </span>
                </label>
                <div className="text-image">
                  {stringsFromServer.site_FilterWifi}{" "}
                </div>
              </div>
              <div className="restoom-checkbox">
                <input
                  type="checkbox"
                  id="restoom"
                  name="restoom"
                  value="restoom"
                  checked={
                    includeArr.find(
                      (include) =>
                        include === IncludesType.RESTOOM ||
                        include === allTypesIncludes
                    )
                      ? true
                      : false
                  }
                  onChange={(e: React.FormEvent<HTMLInputElement>) =>
                    changeSelectedInclude(
                      IncludesType.RESTOOM,
                      e.currentTarget.checked
                    )
                  }
                />
                <label
                  className="restoom-label type-checkbox-label"
                  htmlFor="restoom"
                >
                  <span className="type-checkbox-logo">
                    <Restoom_icon />
                  </span>
                </label>
                <div className="text-image">
                  {stringsFromServer.site_FilterRestroom}{" "}
                </div>
              </div>
              <div className="loading-checkbox">
                <input
                  type="checkbox"
                  id="loading"
                  name="loading"
                  value="loading"
                  checked={
                    includeArr.find(
                      (include) =>
                        include === IncludesType.LOADING ||
                        include === allTypesIncludes
                    )
                      ? true
                      : false
                  }
                  onChange={(e: React.FormEvent<HTMLInputElement>) =>
                    changeSelectedInclude(
                      IncludesType.LOADING,
                      e.currentTarget.checked
                    )
                  }
                />
                <label
                  className="loading-label type-checkbox-label"
                  htmlFor="loading"
                >
                  <span className="type-checkbox-logo">
                    <Loading_icon />
                  </span>
                </label>
                <div className="text-image">
                  {stringsFromServer.site_FilterLoading}{" "}
                </div>
              </div>
              <div className="shopping-checkbox">
                <input
                  type="checkbox"
                  id="shopping"
                  name="shopping"
                  value="shopping"
                  checked={
                    includeArr.find(
                      (include) =>
                        include === IncludesType.SHOPPING ||
                        include === allTypesIncludes
                    )
                      ? true
                      : false
                  }
                  onChange={(e: React.FormEvent<HTMLInputElement>) =>
                    changeSelectedInclude(
                      IncludesType.SHOPPING,
                      e.currentTarget.checked
                    )
                  }
                />
                <label
                  className="shopping-label type-checkbox-label"
                  htmlFor="shopping"
                >
                  <span className="type-checkbox-logo">
                    <Shopping_icon />
                  </span>
                </label>
                <div className="text-image">
                  {stringsFromServer.site_FilterShopping}{" "}
                </div>
              </div>
              <div className="parking-checkbox">
                <input
                  type="checkbox"
                  id="parking"
                  name="parking"
                  value="parking"
                  checked={
                    includeArr.find(
                      (include) =>
                        include === IncludesType.PARKING ||
                        include === allTypesIncludes
                    )
                      ? true
                      : false
                  }
                  onChange={(e: React.FormEvent<HTMLInputElement>) =>
                    changeSelectedInclude(
                      IncludesType.PARKING,
                      e.currentTarget.checked
                    )
                  }
                />
                <label
                  className="parking-label type-checkbox-label"
                  htmlFor="parking"
                >
                  <span className="type-checkbox-logo">
                    <Parking_icon />
                  </span>
                </label>
                <div className="text-image">
                  {stringsFromServer.site_FilterParking}{" "}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  render() {
    return (
      // The main container now gets a ref for focus trapping.
      <div ref={this.filterContainerRef} className={this.getPopupClassName()}>
        {/* Close Icon remains unchanged */}
        <span
          ref={this.closeButtonRef}
          className={`close-icon-popup-filter ${this.props.browserLanguage}`}
          tabIndex={INITIAL_FILTERS_TABINDEX + 1}
          aria-label={
            this.props.browserLanguage === BrowserLanguage.he
              ? "סגור מסנן"
              : "Close filter"
          }
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              this.props.filterPopup();
              this.setState(
                {
                  chargingPowerOpen: false,
                  socketsNumberOpen: false,
                  connectionTypeOpen: false,
                  operatorsOpen: false,
                  paymentsOpen: false,
                  includeOpen: false,
                  ratesOpen: false,
                },
                () => {
                  this.lastFocusedElement?.focus();
                }
              );
            }
          }}  
          onClick={() => {
            this.props.filterPopup();
            this.setState(
              {
                chargingPowerOpen: false,
                socketsNumberOpen: false,
                connectionTypeOpen: false,
                operatorsOpen: false,
                paymentsOpen: false,
                includeOpen: false,
                ratesOpen: false,
              },
              () => {
                this.lastFocusedElement?.focus();
              }
            );
          }}
        >
          <CloseIcon />
        </span>

        {this.props.openFilterPopup
          ? this.getPopupElement()
          : this.getPopupImages()}
        {this.props.openFilterPopup &&
          (this.props.selectedConnectorsArr[0] !== allTypesConnectors ||
            this.props.operatorsArr[0] !== allTypesOperators.toString() ||
            this.props.paymentsArr[0] !== allTypesPayment.toString() ||
            this.props.socektNumber !== 1 ||
            this.props.powerSelected !== 1) && (
            <span
              className={`clear-filter-text ${this.props.browserLanguage}`}
              onClick={() => {
                this.props.handleChangePower(1 as number);
                this.props.handleSocketsNumber(1 as number);
                this.props.selectedConnectorsArr[0] = allTypesConnectors;
                this.props.operatorsArr[0] = allTypesOperators.toString();
                this.props.paymentsArr[0] = allTypesPayment;
                this.setState({
                  connectionTypeOpen: false,
                  chargingPowerOpen: false,
                  socketsNumberOpen: false,
                  operatorsOpen: false,
                  paymentsOpen: false,
                  includeOpen: false,
                  ratesOpen: false,
                });
              }}
              tabIndex={INITIAL_FILTERS_TABINDEX + 8}
              onKeyDown={() => {
                this.props.handleChangePower(1 as number);
                this.props.handleSocketsNumber(1 as number);
                this.props.selectedConnectorsArr[0] = allTypesConnectors;
                this.props.operatorsArr[0] = allTypesOperators.toString();
                this.props.paymentsArr[0] = allTypesPayment;
                this.setState({
                  connectionTypeOpen: false,
                  chargingPowerOpen: false,
                  socketsNumberOpen: false,
                  operatorsOpen: false,
                  paymentsOpen: false,
                  includeOpen: false,
                  ratesOpen: false,
                });
              }}
            >
              {this.getClearFiltersStr()}
            </span>
          )}
      </div>
    );
  }
}

export default Filter;
